import type { City } from '../api/types';
import type { PlaceCoverage } from '../util/coverage';
import { PlaceCoverageWindow } from './PlaceCoverageWindow';

/*
 * One place of a planned round, opened from the round's Coverage tab.
 *
 * The window itself is PlaceCoverageWindow, which the place panel opens too.
 * What this adds is the round: the stop's number on its badge, the way back
 * to it on the round's own map, and the work planned for later, which only
 * means anything measured against a round's date.
 */

export function PlaceCoverageDetail({
  row, city, basemapUrl, onClose, onShowOnMap, onShowDetails,
}: {
  /** The place to report on. Null closes the window. */
  row: PlaceCoverage | null;
  city: City;
  /** The same archive the page's own map draws, so this one is not blank. */
  basemapUrl?: string | null;
  onClose: () => void;
  /** Takes the round's own map to this stop, behind the window. */
  onShowOnMap?: (index: number) => void;
  /** Opens the place's full record — hours, address, what is there. */
  onShowDetails?: (poiId: string) => void;
}) {
  if (!row) return null;

  const { place } = row;

  return (
    <PlaceCoverageWindow
      place={{
        key: place.key,
        name: place.name,
        lat: place.lat,
        lng: place.lng,
        poiId: place.poiId,
        marker: place.marker,
        kind: place.kind,
        index: place.index,
      }}
      coverings={row.coverings}
      later={row.later}
      city={city}
      {...(basemapUrl !== undefined ? { basemapUrl } : {})}
      onClose={onClose}
      {...(onShowOnMap ? { onShowOnMap } : {})}
      {...(onShowDetails ? { onShowDetails } : {})}
    />
  );
}
